"use strict";
/**
 * Inventory Session Request Types
 *
 * Request DTOs for inventory session endpoints.
 *
 * @example POST /api/qvet/inventory-sessions
 * @example POST /api/qvet/inventory-sessions/:id/upload
 * @example POST /api/qvet/inventory-sessions/:id/apply-review
 */
Object.defineProperty(exports, "__esModule", { value: true });
